module.exports = __webpack_public_path__ + "img/even.0e6895b8.svg";